/**
 * @generated SignedSource<<84789a9ee1bdfdb961b9bab3b15deb1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LeadsRoutesDetailsQuery$variables = {
  leadId: string;
};
export type LeadsRoutesDetailsQuery$data = {
  readonly leadById: {
    readonly isVisibilityLead: boolean;
    readonly userCanViewLeadDetails: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"leadDetails_lead" | "leadDetails_leadClaimData">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"leadDetails_root">;
};
export type LeadsRoutesDetailsQuery = {
  response: LeadsRoutesDetailsQuery$data;
  variables: LeadsRoutesDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "leadId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "leadId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanViewLeadDetails",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVisibilityLead",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "min",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "max",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v12 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v4/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = [
  (v4/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v22 = [
  (v14/*: any*/),
  (v4/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Email",
  "kind": "LinkedField",
  "name": "primaryEmail",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referrer",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBroker",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedNumber",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primary",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumbers",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Email",
  "kind": "LinkedField",
  "name": "emails",
  "plural": true,
  "selections": [
    (v25/*: any*/),
    (v32/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "broker",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v24/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v5/*: any*/),
    (v29/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Subscription",
  "kind": "LinkedField",
  "name": "subscription",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v38 = [
  (v4/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v24/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v5/*: any*/),
  (v29/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Organisation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "storageKey": null
  },
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v37/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mortgageIsConstruction",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mortgageMortgageType",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mortgagePropertyUsage",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "LeadStage",
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Pipeline",
      "kind": "LinkedField",
      "name": "pipeline",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "leadType",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v44 = [
  (v7/*: any*/),
  (v4/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "GoogleAddress",
  "kind": "LinkedField",
  "name": "mortgageGoogleAddress",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v47 = [
  (v4/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v26/*: any*/),
  (v24/*: any*/),
  (v39/*: any*/),
  (v37/*: any*/)
],
v48 = [
  (v8/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LeadsRoutesDetailsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "leadDetails_root"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Lead",
        "kind": "LinkedField",
        "name": "leadById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "leadDetails_lead"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "leadDetails_leadClaimData"
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LeadsRoutesDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tenant",
        "kind": "LinkedField",
        "name": "tenantSettings",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelIazi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelWup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelPropertydata",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelPricehubble",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelRealadvisorListings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelRealadvisorTransactions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelRealadvisorPerceived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateModelDetails",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showAdditionalLinks",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activateLandRegistryOwners",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modules",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "name",
            "value": "brokerage"
          }
        ],
        "concreteType": "Pipeline",
        "kind": "LinkedField",
        "name": "pipelines",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LeadStage",
            "kind": "LinkedField",
            "name": "stages",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": "pipelines(name:\"brokerage\")"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "filters",
            "value": {
              "type_in": [
                "appraisal_report"
              ]
            }
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 100
          }
        ],
        "concreteType": "DocTemplateConnection",
        "kind": "LinkedField",
        "name": "docTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DocTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DocTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DocTemplatesTenants",
                    "kind": "LinkedField",
                    "name": "docTemplatesTenants",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tenantId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDefault",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "docTemplates(filters:{\"type_in\":[\"appraisal_report\"]},first:100)"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Lead",
        "kind": "LinkedField",
        "name": "leadById",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Property",
            "kind": "LinkedField",
            "name": "property",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "route",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postcode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "streetNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locality",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PropertyType",
                "kind": "LinkedField",
                "name": "propertyType",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "municipalityObject",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Appraisal",
                "kind": "LinkedField",
                "name": "latestAppraisal",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pricePerSquareMeterBuiltSurface",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pricePerSquareMeterLivingSurface",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rentalValue",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IaziAppraisal",
                    "kind": "LinkedField",
                    "name": "iazi",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IaziAppraisal",
                    "kind": "LinkedField",
                    "name": "iazi_cv",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pricehubble",
                    "kind": "LinkedField",
                    "name": "pricehubble",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WupAppraisal",
                    "kind": "LinkedField",
                    "name": "wup",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PropertydataAppraisal",
                    "kind": "LinkedField",
                    "name": "propertydata",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorListingAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor_listing",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorNaiveListingsAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor_naive_listings",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorOmniMetaAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor_omni_meta",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorTransactionAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor_transaction",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorOpenDataTransactionAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor_open_data_transaction",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorPerceivedAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor_perceived",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfRooms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "livingSurface",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "landSurface",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mimetype",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "uploader",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfBedrooms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfBathrooms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfIndoorParkings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfOutdoorParkings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "constructionYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "renovationYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "balconySurface",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Appraisal",
                "kind": "LinkedField",
                "name": "firstAppraisal",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RealadvisorAppraisal",
                    "kind": "LinkedField",
                    "name": "realadvisor",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "brokersInCatchmentArea",
                "plural": true,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formattedLocality",
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "builtSurface",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfResidentialUnits",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "residentialSurface",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "residentialYearlyRentalIncome",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parkingYearlyRentalIncome",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfCommercialUnits",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commercialSurface",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commercialYearlyRentalIncome",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incomeIncludesParking",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "plotNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appraisable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GoogleAddress",
                "kind": "LinkedField",
                "name": "googleAddress",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRental",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "compositePropertyType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PropertyImage",
                "kind": "LinkedField",
                "name": "propertyImages",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v23/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "owners",
                "plural": true,
                "selections": (v38/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v26/*: any*/),
              (v24/*: any*/),
              (v39/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "phoneNumbers",
                "plural": true,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v15/*: any*/),
                  (v4/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "broker",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": null
              },
              (v27/*: any*/),
              (v28/*: any*/),
              (v5/*: any*/),
              (v29/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Lead",
                "kind": "LinkedField",
                "name": "leads",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": (v44/*: any*/),
                    "storageKey": null
                  },
                  (v45/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "broker",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v26/*: any*/),
              (v24/*: any*/),
              (v39/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "primaryPhoneNumber",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/),
              (v46/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v5/*: any*/),
              (v29/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v43/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Lot",
            "kind": "LinkedField",
            "name": "lot",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rentNet",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rentExtra",
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lotReference",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salePrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mandateType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fixedFee",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commissionRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Property",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PropertyImage",
                "kind": "LinkedField",
                "name": "primaryPropertyImage",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "broker",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "seller",
                "plural": false,
                "selections": (v47/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "kind": "LinkedField",
                "name": "offers",
                "plural": true,
                "selections": [
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocTemplate",
                "kind": "LinkedField",
                "name": "brochureTemplate",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CmaReport",
            "kind": "LinkedField",
            "name": "cmaReports",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DocTemplate",
                "kind": "LinkedField",
                "name": "docTemplate",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              (v46/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyRoute",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyStreetNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyPostcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyLocality",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PropertyType",
            "kind": "LinkedField",
            "name": "appraisalPropertyPropertyType",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mainType",
                "storageKey": null
              },
              (v8/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyHasView",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyOccupied",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyUsage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalOpenToOffer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalMarketTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relationship",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyLivingSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyLandSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyBalconySurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyConstructionYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyRenovationYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyNumberOfFloors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyFloorOfFlat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertySide",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyNumberOfRooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyNumberOfBedrooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyNumberOfBathrooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyNumberOfIndoorParkings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyNumberOfOutdoorParkings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyPlotNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saleHorizon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "buyHorizon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mortgageTerm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalInheritanceNextStep",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalSeparationNextStep",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPerceivedValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalMonthlyGrossRent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPerception",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalNextStep",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mortgageStep",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MortgageAnalysis",
            "kind": "LinkedField",
            "name": "mortgageAnalysis",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxPropertyValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "yearlyRevenues",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "savings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "debt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mortgagePropertyValue",
            "storageKey": null
          },
          (v41/*: any*/),
          (v40/*: any*/),
          (v45/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mortgageIsPropertyIdentified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mortgageBuyingStatus",
            "storageKey": null
          },
          (v42/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mortgageStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receivedMortgageOffer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfBuyers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasDependantChildren",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfDependantChildren",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "occupation",
            "plural": false,
            "selections": (v48/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "nationality",
            "plural": false,
            "selections": (v48/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOfBirth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondPillar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thirdPillar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otherCredits",
            "storageKey": null
          },
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          (v27/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "referringDomain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "landingPageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "callTimes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "sourceOrganisation",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalSellingWith",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ownership",
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requalifiedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completed",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mortgageReportType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appraisalPropertyFormattedAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "potentialDevelopment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "claimedBy",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98d7b60ef9c69a500078632c99b32578",
    "id": null,
    "metadata": {},
    "name": "LeadsRoutesDetailsQuery",
    "operationKind": "query",
    "text": "query LeadsRoutesDetailsQuery(\n  $leadId: ID!\n) {\n  ...leadDetails_root\n  leadById(id: $leadId) {\n    ...leadDetails_lead\n    ...leadDetails_leadClaimData\n    userCanViewLeadDetails\n    isVisibilityLead\n    id\n  }\n}\n\nfragment ActivityEventForm_lead on Lead {\n  id\n  property {\n    formattedAddress\n    id\n  }\n  contact {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  __typename\n}\n\nfragment ActivityForm_lead on Lead {\n  ...ActivityNoteForm_lead\n  ...ActivityEventForm_lead\n}\n\nfragment ActivityNoteForm_lead on Lead {\n  id\n  property {\n    formattedAddress\n    id\n  }\n  contact {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  __typename\n}\n\nfragment EmailFormDataWrapper_lead on Lead {\n  __typename\n  id\n  broker {\n    id\n    firstName\n    lastName\n    gender\n    primaryEmail {\n      id\n      email\n    }\n    primaryPhoneNumber {\n      id\n      formattedNumber\n    }\n    organisation {\n      id\n      name\n      formattedAddress\n    }\n    title\n    language\n  }\n  contact {\n    id\n  }\n  lot {\n    id\n    rentNet\n    rentExtra\n    title\n    lotReference\n    salePrice\n    mandateType\n    fixedFee\n    commissionRate\n    property {\n      id\n      formattedAddress\n    }\n    primaryPropertyImage {\n      image {\n        url\n        id\n      }\n      id\n    }\n    broker {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    seller {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    offers {\n      status\n      amount\n      createdAt\n      id\n    }\n    brochureTemplate {\n      id\n    }\n    product {\n      id\n    }\n  }\n  cmaReports {\n    id\n    updatedAt\n    docTemplate {\n      id\n    }\n  }\n  property {\n    id\n    route\n    postcode\n    streetNumber\n    locality\n    state\n    formattedAddress\n    propertyType {\n      label\n      id\n    }\n    municipalityObject {\n      label\n      id\n    }\n    latestAppraisal {\n      realadvisor {\n        min\n        max\n        value\n      }\n      id\n    }\n    numberOfRooms\n    livingSurface\n    landSurface\n  }\n}\n\nfragment FeedEmailForm_lead on Lead {\n  ...EmailFormDataWrapper_lead\n}\n\nfragment FeedNewForm_lead on Lead {\n  ...ActivityForm_lead\n  __typename\n  stage {\n    pipeline {\n      leadType\n      id\n    }\n    id\n  }\n  contact {\n    phoneNumbers {\n      number\n      primary\n      createdAt\n      id\n    }\n    id\n  }\n}\n\nfragment Feed_lead on Lead {\n  ...FeedNewForm_lead\n  ...FeedEmailForm_lead\n  __typename\n  id\n}\n\nfragment LeadDetailsAnswersCard_lead on Lead {\n  appraisalPropertyRoute\n  appraisalPropertyStreetNumber\n  appraisalPropertyPostcode\n  appraisalPropertyLocality\n  appraisalPropertyPropertyType {\n    mainType\n    label\n    id\n  }\n  appraisalPropertyHasView\n  appraisalPropertyOccupied\n  appraisalPropertyUsage\n  appraisalOpenToOffer\n  appraisalMarketTime\n  relationship\n  appraisalPropertyLivingSurface\n  appraisalPropertyLandSurface\n  appraisalPropertyBalconySurface\n  appraisalPropertyConstructionYear\n  appraisalPropertyRenovationYear\n  appraisalPropertyNumberOfFloors\n  appraisalPropertyFloorOfFlat\n  appraisalPropertySide\n  appraisalPropertyNumberOfRooms\n  appraisalPropertyNumberOfBedrooms\n  appraisalPropertyNumberOfBathrooms\n  appraisalPropertyNumberOfIndoorParkings\n  appraisalPropertyNumberOfOutdoorParkings\n  appraisalPropertyPlotNumber\n  appraisalReason\n  saleHorizon\n  buyHorizon\n  mortgageTerm\n  appraisalInheritanceNextStep\n  appraisalSeparationNextStep\n  appraisalPerceivedValue\n  appraisalMonthlyGrossRent\n  appraisalPerception\n  appraisalNextStep\n  property {\n    numberOfRooms\n    numberOfBedrooms\n    numberOfBathrooms\n    numberOfIndoorParkings\n    numberOfOutdoorParkings\n    constructionYear\n    renovationYear\n    livingSurface\n    landSurface\n    balconySurface\n    firstAppraisal {\n      realadvisor {\n        value\n      }\n      id\n    }\n    id\n  }\n  mortgageStep\n  mortgageAnalysis {\n    maxPropertyValue\n  }\n  yearlyRevenues\n  savings\n  debt\n  mortgagePropertyValue\n  mortgageMortgageType\n  mortgageIsConstruction\n  mortgageGoogleAddress {\n    formattedAddress\n    id\n  }\n  mortgageIsPropertyIdentified\n  mortgageBuyingStatus\n  mortgagePropertyUsage\n  mortgageStatus\n  receivedMortgageOffer\n  numberOfBuyers\n  hasDependantChildren\n  numberOfDependantChildren\n  occupation {\n    label\n    id\n  }\n  nationality {\n    label\n    id\n  }\n  dateOfBirth\n  secondPillar\n  thirdPillar\n  otherCredits\n  firstName\n  lastName\n  emailAddress\n  phoneNumber\n  referrer\n  referringDomain\n  landingPageUrl\n  callTimes\n  sourceOrganisation {\n    name\n    id\n  }\n}\n\nfragment LeadDetailsLatestAppraisalCard_lead on Lead {\n  id\n  userCanViewLeadDetails\n  property {\n    id\n    appraisable\n    latestAppraisal {\n      ...appraisalGraph_appraisal\n      realadvisor {\n        min\n        max\n        value\n        pricePerSquareMeterBuiltSurface\n        pricePerSquareMeterLivingSurface\n        rentalValue\n      }\n      updatedAt\n      id\n    }\n    countryCode\n  }\n}\n\nfragment LeadDetailsLatestAppraisalCard_root on Query {\n  tenantSettings {\n    ...appraisalGraph_tenantSettings\n    id\n    activateModelDetails\n  }\n  docTemplates(first: 100, filters: {type_in: [\"appraisal_report\"]}) {\n    edges {\n      node {\n        id\n        name\n        active\n        docTemplatesTenants {\n          tenantId\n          isDefault\n        }\n      }\n    }\n  }\n}\n\nfragment LeadDetailsMap_property on Property {\n  id\n  lat\n  lng\n  googleAddress {\n    lat\n    lng\n    id\n  }\n}\n\nfragment appraisalGraph_appraisal on Appraisal {\n  iazi {\n    min\n    max\n    value\n    id\n  }\n  iazi_cv {\n    min\n    max\n    value\n    id\n  }\n  pricehubble {\n    min\n    max\n    value\n    id\n  }\n  wup {\n    min\n    max\n    value\n    id\n  }\n  propertydata {\n    min\n    max\n    value\n    id\n  }\n  realadvisor_listing {\n    min\n    max\n    value\n    id\n  }\n  realadvisor_naive_listings {\n    min\n    max\n    value\n    id\n  }\n  realadvisor_omni_meta {\n    min\n    max\n    value\n    id\n  }\n  realadvisor_transaction {\n    min\n    max\n    value\n    id\n  }\n  realadvisor_open_data_transaction {\n    min\n    max\n    value\n    id\n  }\n  realadvisor_perceived {\n    min\n    max\n    value\n    id\n  }\n  realadvisor {\n    min\n    max\n    value\n  }\n}\n\nfragment appraisalGraph_tenantSettings on Tenant {\n  activateModelIazi\n  activateModelWup\n  activateModelPropertydata\n  activateModelPricehubble\n  activateModelRealadvisorListings\n  activateModelRealadvisorTransactions\n  activateModelRealadvisorPerceived\n}\n\nfragment filesList_files on File {\n  id\n  name\n  url\n  mimetype\n  createdAt\n  uploader {\n    firstName\n    lastName\n    id\n  }\n}\n\nfragment financingLeadCreationDrawer_user on User {\n  id\n  firstName\n  lastName\n  primaryEmail {\n    email\n    id\n  }\n  primaryImage {\n    url\n    id\n  }\n  organisation {\n    name\n    formattedAddress\n    id\n  }\n  subscription {\n    status\n    id\n  }\n}\n\nfragment financingLeadsCard_user on User {\n  ...financingLeadCreationDrawer_user\n  id\n  leads {\n    id\n    mortgageIsConstruction\n    mortgageMortgageType\n    mortgagePropertyUsage\n    stage {\n      pipeline {\n        leadType\n        id\n      }\n      id\n    }\n    property {\n      formattedAddress\n      id\n    }\n    mortgageGoogleAddress {\n      formattedAddress\n      id\n    }\n  }\n}\n\nfragment leadBrokerCard_lead on Lead {\n  id\n  broker {\n    ...userEditableCard_user\n    displayName\n    primaryImage {\n      url\n      id\n    }\n    id\n  }\n  contact {\n    broker {\n      ...userEditableCard_user\n      id\n    }\n    id\n  }\n  property {\n    id\n    brokersInCatchmentArea {\n      id\n    }\n  }\n}\n\nfragment leadBrokerCard_root on Query {\n  me {\n    isAdmin\n    id\n  }\n}\n\nfragment leadCmaCard_lead on Lead {\n  id\n  property {\n    appraisable\n    id\n  }\n  contact {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  cmaReports {\n    id\n    updatedAt\n    language\n    createdBy {\n      id\n      displayName\n    }\n    docTemplate {\n      id\n    }\n  }\n}\n\nfragment leadContactCard_RelationshipItem on Lead {\n  id\n  relationship\n}\n\nfragment leadContactCard_lead on Lead {\n  ...leadContactCard_RelationshipItem\n  id\n  contact {\n    ...userEditableCard_user\n    displayName\n    id\n  }\n  createdBy {\n    id\n  }\n}\n\nfragment leadControls_lead on Lead {\n  id\n  ...leadDeleteDialog_lead\n  completed\n  stage {\n    id\n  }\n}\n\nfragment leadControls_root on Query {\n  me {\n    isAdmin\n    id\n  }\n  pipelines(name: \"brokerage\") {\n    stages {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment leadDeleteDialog_lead on Lead {\n  ...leadSnippet_lead\n  id\n}\n\nfragment leadDetails_lead on Lead {\n  ...Feed_lead\n  ...leadFilesCard_lead\n  ...LeadDetailsAnswersCard_lead\n  ...leadBrokerCard_lead\n  ...leadContactCard_lead\n  ...leadSnippet_lead\n  ...leadControls_lead\n  ...LeadDetailsLatestAppraisalCard_lead\n  ...leadLotCard_lead\n  ...leadCmaCard_lead\n  id\n  appraisalPropertyFormattedAddress\n  potentialDevelopment\n  userCanViewLeadDetails\n  contact {\n    ...financingLeadsCard_user\n    id\n    firstName\n    lastName\n  }\n  property {\n    ...LeadDetailsMap_property\n    ...propertyCard_property\n    id\n    formattedAddress\n    formattedLocality\n    owners {\n      id\n    }\n  }\n}\n\nfragment leadDetails_leadClaimData on Lead {\n  id\n  claimedBy {\n    id\n  }\n}\n\nfragment leadDetails_root on Query {\n  ...propertyCard_root\n  ...leadBrokerCard_root\n  ...leadControls_root\n  ...LeadDetailsLatestAppraisalCard_root\n  me {\n    modules\n    isAdmin\n    id\n  }\n  tenantSettings {\n    id\n    showAdditionalLinks\n    activateLandRegistryOwners\n  }\n}\n\nfragment leadFilesCard_lead on Lead {\n  id\n  property {\n    id\n    files {\n      ...filesList_files\n      id\n    }\n  }\n}\n\nfragment leadLotCard_lead on Lead {\n  id\n  lot {\n    id\n  }\n}\n\nfragment leadQualificationFunnel_lead on Lead {\n  appraisalReason\n  appraisalOpenToOffer\n  appraisalSellingWith\n  appraisalMarketTime\n  appraisalNextStep\n  appraisalMonthlyGrossRent\n  appraisalPerceivedValue\n  appraisalSeparationNextStep\n  appraisalInheritanceNextStep\n  saleHorizon\n  appraisalPerception\n  buyHorizon\n  ownership\n  relationship\n  mortgageTerm\n  mortgageBuyingStatus\n  mortgageStatus\n  receivedMortgageOffer\n  property {\n    countryCode\n    propertyType {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment leadSnippet_lead on Lead {\n  ...leadQualificationFunnel_lead\n  ...leadUpdatedTimeAgo_lead\n  id\n  stage {\n    pipeline {\n      leadType\n      id\n    }\n    id\n  }\n  referrer\n  referringDomain\n  landingPageUrl\n  completed\n  userCanViewLeadDetails\n  appraisalPerceivedValue\n  appraisalPerception\n  appraisalPropertyUsage\n  relationship\n  appraisalPropertyOccupied\n  mortgagePropertyValue\n  mortgagePropertyUsage\n  mortgageIsConstruction\n  mortgageMortgageType\n  mortgageReportType\n  mortgageAnalysis {\n    maxPropertyValue\n  }\n  mortgageGoogleAddress {\n    formattedAddress\n    id\n  }\n  appraisalPropertyFormattedAddress\n  property {\n    countryCode\n    formattedAddress\n    formattedLocality\n    lat\n    lng\n    livingSurface\n    builtSurface\n    landSurface\n    numberOfRooms\n    numberOfBedrooms\n    numberOfResidentialUnits\n    residentialSurface\n    residentialYearlyRentalIncome\n    parkingYearlyRentalIncome\n    numberOfCommercialUnits\n    commercialSurface\n    commercialYearlyRentalIncome\n    incomeIncludesParking\n    plotNumber\n    propertyType {\n      label\n      name\n      id\n    }\n    latestAppraisal {\n      realadvisor {\n        min\n        max\n      }\n      id\n    }\n    id\n  }\n  contact {\n    firstName\n    lastName\n    referrer\n    id\n  }\n}\n\nfragment leadUpdatedTimeAgo_lead on Lead {\n  createdAt\n  requalifiedAt\n}\n\nfragment propertyCard_property on Property {\n  id\n  formattedAddress\n  isRental\n  livingSurface\n  builtSurface\n  numberOfRooms\n  numberOfBedrooms\n  compositePropertyType\n  propertyType {\n    label\n    id\n  }\n  propertyImages {\n    title\n    image {\n      url\n      id\n    }\n    id\n  }\n  latestAppraisal {\n    realadvisor {\n      min\n      max\n    }\n    id\n  }\n  municipalityObject {\n    slug\n    id\n  }\n  owners {\n    id\n    ...userEditableCard_user\n  }\n}\n\nfragment propertyCard_root on Query {\n  tenantSettings {\n    id\n  }\n}\n\nfragment userAvatar_user on User {\n  id\n  firstName\n  lastName\n  primaryImage {\n    url\n    id\n  }\n  primaryEmail {\n    email\n    id\n  }\n  referrer\n  isBroker\n  isAdmin\n}\n\nfragment userEditableCard_user on User {\n  ...userSummary_user\n  id\n  firstName\n  lastName\n  primaryEmail {\n    email\n    id\n  }\n  primaryImage {\n    url\n    id\n  }\n  organisation {\n    name\n    formattedAddress\n    id\n  }\n  subscription {\n    status\n    id\n  }\n}\n\nfragment userSummary_user on User {\n  ...userAvatar_user\n  id\n  displayName\n  organisation {\n    id\n    name\n  }\n  phoneNumbers {\n    formattedNumber\n    number\n    primary\n    id\n  }\n  emails {\n    email\n    primary\n    id\n  }\n  broker {\n    ...userAvatar_user\n    id\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "33a2b31206f391926d8ee3228f0a2150";

export default node;
